import React from 'react';
import cx from 'classnames';
//import { tv } from 'tailwind-variants';

import FlexRow, { FlexRowProps } from './FlexRow';

const FieldLabelW = 200 as const;
const FieldValueW = 250 as const;
const FieldW = FieldLabelW + FieldValueW;

/*export interface FieldSlots {
  label?:			string;
}*/

export interface FieldProps extends FlexRowProps {
  label?:			string;
  labelWide?:		boolean;
  //slots?:			FieldSlots;
}

const Field = (fprops: FieldProps) => {
  const {children, className, label, labelWide, flex, ...props} = fprops;
  
  /*const field = tv({
    slots: {
      label:	"min-w-[150px] font-medium text-[18px] " +
      			(	slots &&
      				slots.label
      				?	slots.label
      				:	''
      			),
    }
  });
  
  const fv = field();*/
  
  const classes = cx(
    'h-[48px]',
    className,
  );
  
  const f = flex === undefined
  			?	0
  			:	flex;
  
  return (
  <FlexRow className={classes}
           flex={f}
           {...props}>
    <FlexRow flex={labelWide ? 1 : 0}
             className="min-w-[150px] r14">
      { label }
    </FlexRow>
    <FlexRow flex={labelWide ? 0 : 1}>
      { children }
    </FlexRow>
  </FlexRow>
  );
};

export const WelField = (fprops: FieldProps) => {
  const {children, className, label, ...props} = fprops;
  
  const classes = cx(
    'h-[24px]',
    'max-w-[448px]',
    className,
  );
  
  return (
  <FlexRow className={classes}
           {...props}>
  {label &&
    <FlexRow className="font-medium r14 !text-black">
      { label }
    </FlexRow>
  }
    <FlexRow flex={label ? 0 : 1}
             className="gap-[12px]">
      { children }
    </FlexRow>
  </FlexRow>
  );
};

export interface NumberTextProps {
  children?:			React.ReactNode;
}

export const NumberText = (props: NumberTextProps) => {
  return (
  <span className="text-[#1B69AA]">
    { props.children }
  </span>
  );
};

export default Field;

